package org.example.zone360.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.Edge
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.backgroundPosition
import com.varabyte.kobweb.compose.ui.modifiers.backgroundSize
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.s

@Composable
fun ShimmerCircle(modifier: Modifier = Modifier) {
    var offsetX by remember { mutableStateOf((-100).percent) }

    LaunchedEffect(Unit) {
        while (true) {
            offsetX = (-100).percent
            delay(100) // small delay to allow CSS transition reset
            offsetX = 100.percent
            delay(800) // wait for the transition to complete
        }
    }

    Box(
        modifier = modifier
            .backgroundColor(Colors.Transparent)
            .overflow(Overflow.Hidden)
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundImage(
                    linearGradient(LinearGradient.Direction.ToRight) {
                        add(Colors.LightGray)
                        add(Colors.White.copyf(alpha = 0.7f))
                        add(Colors.LightGray)
                    }
                )
                .backgroundSize(BackgroundSize.of(200.percent, 100.percent))
                .animateShimmerX(offsetX)
                .transition(Transition.of("background-position", 0.8.s))
        )
    }
}

fun Modifier.animateShimmerX(offsetX: CSSSizeValue<CSSUnit.percent>): Modifier {
    return this.backgroundPosition(
        BackgroundPosition.of(
            CSSPosition(
                Edge.Left(offsetX),
                Edge.Top(0.percent)
            )
        )
    )
}
